import { render, staticRenderFns } from "./ModelEditViewPopup.vue?vue&type=template&id=72cdcd0e&scoped=true&"
import script from "./ModelEditViewPopup.vue?vue&type=script&lang=js&"
export * from "./ModelEditViewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdcd0e",
  null
  
)

export default component.exports